import { MultiTechAreaGroup } from 'editor/src/store/app/types';

// Exact match on a tech option's spread first; otherwise the area whose canonical name prefixes the spread
// name, so a spread inside an area that is not one of its tech options still gets the area's label.
function findMultiTechAreaGroup(
  groups: MultiTechAreaGroup[] | undefined,
  spreadName: string | undefined,
): MultiTechAreaGroup | null {
  if (!groups?.length || !spreadName) {
    return null;
  }
  const exact = groups.find((g) => g.options.some((opt) => opt.spreadName === spreadName));
  if (exact) {
    return exact;
  }
  const lcName = spreadName.toLowerCase();
  return (
    groups.find((g) => {
      const canonical = g.canonicalName.toLowerCase();
      return lcName === canonical || lcName.startsWith(`${canonical}-`);
    }) ?? null
  );
}

export default findMultiTechAreaGroup;
